import { joinPathsStringUtil, pickObjectUtil } from 'packages/src'
import getAssociationKeysReduxUtil from '../../../../utils/get-associations-keys'
import { getPathReduxUtil, getValueReduxUtil } from '../../../../utils'
import { REDUX_MODEL_KEY } from '../../../../constants'
import { addReferenceReduxReducerUtil } from '../add-reference'

export function addReferenceToAssociationsReduxReducerUtil (state, instance, updates) {
  const associationKeys = getAssociationKeysReduxUtil(instance)
  if (!associationKeys.length) {
    return state
  }

  const associationsUpdated = pickObjectUtil(updates, associationKeys)
  const keys = Object.keys(associationsUpdated)
  return keys.reduce((updatedState, associationKey) => {
    let association = getValueReduxUtil(instance, associationKey)
    if (!Array.isArray(association)) {
      association = [association]
    }

    return association.reduce((newState, associationElem) => {
      // Add the referencePath to the list of paths referencing the pointer
      return addReferenceReduxReducerUtil({
        instance: associationElem,
        referencePath: joinPathsStringUtil(
          getPathReduxUtil(instance),
          REDUX_MODEL_KEY.CHANGED,
          associationKey
        ),
        state: newState
      })
    }, updatedState)
  }, state)
}
